import { timeMeasurement } from '@pkg/utils';

const EASE_CUBIC = [0.6, 0, 0.2, 1];

// TODO: These motion tokens should be global and not scoped
// to `FloorGame`. This is here only until we have shipped
// `FloorGame` and have time to re-evaluate how we share colors.
export const floorGameDuration = {
    fastest: 40,
    faster: 80,
    fast: 120,
    normal: 200,
    slow: 280,
    slower: 360,
    slowest: 440,
    crawl: 680,
};

export const floorGameEasing = {
    cubic: `cubic-bezier(${EASE_CUBIC})`,
};

export const framerMotion = {
    duration: {
        fastest: floorGameDuration.fastest / timeMeasurement.msPerSec,
        faster: floorGameDuration.faster / timeMeasurement.msPerSec,
        fast: floorGameDuration.fast / timeMeasurement.msPerSec,
        normal: floorGameDuration.normal / timeMeasurement.msPerSec,
        slow: floorGameDuration.slow / timeMeasurement.msPerSec,
        slower: floorGameDuration.slower / timeMeasurement.msPerSec,
        slowest: floorGameDuration.slowest / timeMeasurement.msPerSec,
        crawl: floorGameDuration.crawl / timeMeasurement.msPerSec,
    },
    easing: {
        cubic: EASE_CUBIC,
    },
};
